/**
 * American Vek: <av-ca-dialog> opens its native <dialog> (CA explanation) from the CA badge,
 * so the shopper stays on the product page. Closes on the close button, Esc and backdrop click.
 */
class AvCaDialog extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.opener = this.querySelector('[ref-open]');
    this.opener?.addEventListener('click', this.open);
    this.querySelector('[ref-close]')?.addEventListener('click', this.close);
    this.dialog?.addEventListener('click', this.onBackdrop);
    this.dialog?.addEventListener('close', () => this.opener?.focus());
  }

  open = () => this.dialog?.showModal();

  close = () => this.dialog?.close();

  onBackdrop = (event) => {
    if (event.target !== this.dialog) return;
    const rect = this.dialog.getBoundingClientRect();
    const inside =
      event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
    if (!inside) this.close();
  };
}

if (!customElements.get('av-ca-dialog')) customElements.define('av-ca-dialog', AvCaDialog);
